import template from './working-days-and-time.jade';
import workingDaysOptions from '../../../enums/working-days-type';
import validation from '../../../services/validation';

export default angular
  .module('cian.addForm.workingDaysAndTime', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutBuildingWorkingDaysAndTime', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      '$scope',
      'deviceService',
      function ($scope, deviceService) {
        this.isMobile = deviceService.isMobile;
        this.workingDaysOptions = workingDaysOptions;
        this.ad.building.openingHours = this.ad.building.openingHours || {};
        this.ad.building.openingHours.type = this.ad.building.openingHours.type || 'specific';
        this.isTimeDisabled = () => {
          return this.ad.building && this.ad.building.openingHours
            ? this.ad.building.openingHours.type === 'roundTheClock'
            : false;
        };

        const validationTimeFrom = validation(this.form, 'building.openingHours.from', {
          time: 'Укажите время работы, например: 10 или 10:30',
        });

        const validationTimeTo = validation(this.form, 'building.openingHours.to', {
          time: 'Укажите время работы, например: 10 или 10:30',
        });

        this.validationTimeInvalid = () => validationTimeFrom.invalid() || validationTimeTo.invalid();
        this.validationTimeMessage = () => validationTimeFrom.message().trim() || validationTimeTo.message();

        let { from: tempFrom, to: tempTo } = this.ad.building.openingHours;

        $scope.$watch(
          () => this.ad.building,
          building => {
            const { openingHours = {} } = building;
            const { type } = openingHours;
            if (type === 'roundTheClock') {
              ({ from: tempFrom, to: tempTo } = openingHours);
              this.ad.building.openingHours = {
                ...openingHours,
                from: undefined,
                to: undefined,
              };
            } else if (type === 'specific') {
              this.ad.building.openingHours = {
                ...openingHours,
                from: tempFrom,
                to: tempTo,
              };
            }
          },
        );
      },
    ],
    controllerAs: 'workingDaysAndTime',
    template,
  })).name;
